import { Skeleton } from "@/common/components/Skeleton";
import { formatCnpj } from "@/common/utils/formatters";
import useCompanyBranchWithFiscalDocumentIssuerData from "../hooks/useCompanyBranchWithFiscalDocumentIssuerData";

const InssuanceData = ({ companyBranchId }: { companyBranchId?: string | undefined }) => {
  const {
    data: companyBranchFiscalDocumentIssuerData,
    isPending: companyBranchFiscalDocumentIssuerDataIsPending,
  } = useCompanyBranchWithFiscalDocumentIssuerData({
    companyBranchId,
  });

  if (companyBranchFiscalDocumentIssuerDataIsPending) {
    return (
      <div className="flex flex-col gap-3">
        <h3 className="text-xl font-bold">Dados para emissão</h3>

        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <p className="italic font-light text-xs">CNPJ</p>

            <Skeleton className="w-56" />
          </div>

          <div className="flex flex-col gap-1">
            <p className="italic font-light text-xs">Razão social</p>

            <Skeleton className="w-64" />
          </div>

          <div className="flex flex-col gap-1">
            <p className="italic font-light text-xs">Inscrição estadual</p>

            <Skeleton className="w-32" />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-3">
      <h3 className="text-xl font-bold">Dados para emissão</h3>

      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <p className="italic font-light text-xs">CNPJ</p>
          <p className="font-bold text-md">
            {companyBranchFiscalDocumentIssuerData?.fiscal_document_issuer_cnpj
              ? formatCnpj(companyBranchFiscalDocumentIssuerData?.fiscal_document_issuer_cnpj)
              : '--'}
          </p>
        </div>

        <div className="flex flex-col gap-1">
          <p className="italic font-light text-xs">Razão social</p>
          <p className="font-bold text-md">
            {companyBranchFiscalDocumentIssuerData?.fiscal_document_issuer_official_name || '--'}
          </p>
        </div>

        <div className="flex flex-col gap-1">
          <p className="italic font-light text-xs">Inscrição estadual</p>
          <p className="font-bold text-md">
            {companyBranchFiscalDocumentIssuerData?.fiscal_document_issuer_state_inscription || '--'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default InssuanceData;
